<template>
  <div id="gritter-notice-wrapper" class="normalgritter">
    <div>
      <portal-target name="validationmessages" slim></portal-target>
      <template v-for="(group, gindex) in notifications">
        <span v-if="group.visible" :id="'grittgroup' + group.groupname" class="grittgroup" :key="gindex">
          <div
            class="groepsluiten transdown"
            groep="help"
            :class="{ active: group.messages.filter((m) => m.animactive).length !== 0 }"
          >
            <div class="groepheader" :class="group.color">
              <span
                @click="toggleNotifications(group.groupname)"
                class="glyphicon glyphicon-remove"
                aria-hidden="true"
              ></span>
              <span class="gritterheadertitle">{{ getnotificationTitle(group.groupname) }}</span>
            </div>
            <template v-for="(m, index) in group.messages">
              <div
                :key="gindex + '_' + index"
                class="gritter-item-wrapper transdown"
                :class="{ [group.color]: true, active: m.animactive }"
                role="alert"
                @mouseenter="!m.sticky ? mouseEnterNotifications(group.groupname) : null"
                @mouseleave="!m.sticky ? mouseLeaveNotifications(group.groupname) : null"
              >
                <div class="gritter-top"></div>
                <div class="gritter-item" @click="CreateanchorlinkInNotification(m)">
                  <div class="gritter-without-image">
                    <p v-html="m.message"></p>
                  </div>
                  <div style="clear: both"></div>
                </div>
                <div class="gritter-bottom"></div>
              </div>
            </template>
          </div>
        </span>
      </template>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapGetters(['notifications', 'getnotificationTitle']),
  },
  methods: {
    ...mapMutations(['toggleNotifications', 'mouseEnterNotifications', 'mouseLeaveNotifications']),
    CreateanchorlinkInNotification: (message) => {
      // dit zijn anker links voor de metavelden in asp.net
      if ($('.MetafieldValidator[gritterid="' + message.guid + '"]').length !== 0) {
        $('html, body').animate(
          {
            scrollTop:
              $('.MetafieldValidator[gritterid="' + message.guid + '"]').offset().top -
              $('#fixedcontainer').height() -
              20,
          },
          200
        )
      }
    },
  },
  props: {
    fixedcontainerHeight: {
      type: Number,
      default: 0,
    },
  },
}
</script>
<style scoped>
.transdown {
  overflow: hidden;
}
.transdown {
  transform: translateY(200%);
  transition: 0.4s ease-in-out;
}

.transdown.active {
  transform: translateY(0);
}
</style>
